import React from 'react';

const DsSignedView = () => {
  return (
    <div>
      Form signed and submitted. Returning you to the site.
    </div>
  );
};

export default DsSignedView;
